(function(){
  'use strict';
  var qs=function(s,r){return (r||document).querySelector(s);};
  var qsa=function(s,r){return [].slice.call((r||document).querySelectorAll(s));};
  var lock=function(b){document.body.style.overflow=b?'hidden':'';};
  var t=function(k,d){return (window.SX&&window.SX.strings&&window.SX.strings[k])||d||k;};

  /* Header scroll state */
  var header=qs('[data-site-header]');
  window.addEventListener('scroll',function(){if(header)header.classList.toggle('is-scrolled',window.scrollY>20);},{passive:true});

  /* Menu drawer */
  var md=qs('[data-menu-drawer]');
  function openMenu(){if(!md)return;md.classList.add('is-open');md.setAttribute('aria-hidden','false');document.body.classList.add('sx-menu-open');lock(true);}
  function closeMenu(){if(!md)return;md.classList.remove('is-open');md.setAttribute('aria-hidden','true');document.body.classList.remove('sx-menu-open');if(!document.body.classList.contains('sx-cart-open'))lock(false);}
  qsa('[data-menu-open]').forEach(function(b){b.addEventListener('click',openMenu);});
  qsa('[data-menu-close]').forEach(function(b){b.addEventListener('click',closeMenu);});
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeMenu();closeCart();}});

  /* Cart drawer */
  var cd=qs('[data-cart-drawer]'),cb=qs('[data-cart-drawer-body]'),ct=qs('[data-cart-drawer-title]');
  var rt=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  rt=rt.replace(/\/$/,'');
  function esc(v){return String(v||'').replace(/[&<>"']/g,function(c){return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];});}
  function fmt(c,cur){try{return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:cur||'EUR'}).format((c||0)/100);}catch(e){return ((c||0)/100).toFixed(2)+' '+(cur||'EUR');}}
  function updCount(n){qsa('[data-cart-count]').forEach(function(el){el.textContent=n||0;el.classList.toggle('is-empty',!n);});}
  function render(cart,added){
    if(!cb)return;
    updCount(cart.item_count||0);
    if(ct)ct.textContent=added?t('added','Added to bag'):t('bag','Your bag');
    if(!cart.items||cart.items.length===0){cb.innerHTML='<div class="sx-cart-empty"><p class="sx-muted">'+t('empty','Your bag is empty.')+'</p></div>';return;}
    var html=cart.items.map(function(it){
      var v=it.variant_title&&it.variant_title!=='Default Title'?'<div class="sx-cart-item__variant">'+esc(it.variant_title)+'</div>':'';
      var img=it.image?'<img src="'+it.image+'" alt="'+esc(it.product_title)+'">':'';
      return '<div class="sx-cart-item"><div class="sx-cart-item__img">'+img+'</div><div><div class="sx-cart-item__title">'+esc(it.product_title)+'</div>'+v+'<div class="sx-cart-qty"><button class="sx-cart-qty__btn" data-qa="d" data-k="'+esc(it.key)+'" data-q="'+it.quantity+'">−</button><span>'+it.quantity+'</span><button class="sx-cart-qty__btn" data-qa="i" data-k="'+esc(it.key)+'" data-q="'+it.quantity+'">+</button><button class="sx-cart-rm" data-rm data-k="'+esc(it.key)+'">×</button></div></div><div class="sx-cart-item__price">'+fmt(it.final_line_price,cart.currency)+'</div></div>';
    }).join('');
    cb.innerHTML=html+'<div class="sx-cart-subtotal"><span>'+t('subtotal','Subtotal')+'</span><strong>'+fmt(cart.total_price,cart.currency)+'</strong></div>';
  }
  function fetchCart(added){return fetch(rt+'/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(c){render(c,added);return c;});}
  function changeLine(k,q){return fetch(rt+'/cart/change.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:k,quantity:q})}).then(function(r){if(!r.ok)throw 0;return r.json();}).then(function(c){render(c,false);}).catch(function(){location.reload();});}
  function openCart(added){if(!cd)return;cd.classList.add('is-open');cd.setAttribute('aria-hidden','false');document.body.classList.add('sx-cart-open');lock(true);fetchCart(added).catch(function(){});}
  function closeCart(){if(!cd)return;cd.classList.remove('is-open');cd.setAttribute('aria-hidden','true');document.body.classList.remove('sx-cart-open');if(!document.body.classList.contains('sx-menu-open'))lock(false);}
  qsa('[data-cart-open]').forEach(function(a){a.addEventListener('click',function(e){if(!cd)return;e.preventDefault();openCart(false);});});
  qsa('[data-cart-close]').forEach(function(b){b.addEventListener('click',closeCart);});
  if(cb)cb.addEventListener('click',function(e){
    var q=e.target.closest('[data-qa]');if(q){var k=q.getAttribute('data-k'),cur=parseInt(q.getAttribute('data-q')||'1',10),act=q.getAttribute('data-qa');changeLine(k,act==='i'?cur+1:Math.max(1,cur-1));return;}
    var r=e.target.closest('[data-rm]');if(r)changeLine(r.getAttribute('data-k'),0);
  });
  function ajaxAdd(form,btn){
    if(!form)return;var fd=new FormData(form);
    if(btn){btn.disabled=true;btn.dataset.o=btn.textContent;btn.textContent=t('adding','Adding…');}
    fetch(rt+'/cart/add.js',{method:'POST',credentials:'same-origin',body:fd,headers:{'Accept':'application/json'}})
      .then(function(r){if(!r.ok)throw 0;return r.json();})
      .then(function(){return fetchCart(true);})
      .then(function(){openCart(true);})
      .catch(function(){form.submit();})
      .finally(function(){if(btn){btn.disabled=false;btn.textContent=btn.dataset.o||t('add','Add to bag');}});
  }

  /* PRODUCT — variants */
  qsa('[data-product-root]').forEach(function(root){
    var sel=qs('[data-variant-select]',root),form=qs('.sx-product-form',root),satc=qs('[data-satc]',root),satcBtn=qs('[data-satc-submit]',root);
    if(form)form.addEventListener('submit',function(e){e.preventDefault();ajaxAdd(form,qs('[data-add]',root));});
    if(satcBtn&&form)satcBtn.addEventListener('click',function(){var b=qs('[data-add]',root);if(b&&!b.disabled){if(typeof form.requestSubmit==='function')form.requestSubmit();else ajaxAdd(form,b);}});
    function updSatc(){if(!satc||window.innerWidth>990)return;var b=qs('[data-add]',root);if(!b)return;var r=b.getBoundingClientRect();satc.style.display=(r.bottom<0||r.top>window.innerHeight)?'flex':'none';}
    if(satc){window.addEventListener('scroll',updSatc,{passive:true});window.addEventListener('resize',updSatc);updSatc();}
    var vNode=qs('[data-variants]',root);if(!vNode||!sel)return;
    var variants=[];try{variants=JSON.parse(vNode.textContent);}catch(e){}
    var so=[];
    qsa('[data-oi]',root).forEach(function(g){
      var i=Number(g.getAttribute('data-oi')),a=qs('.is-active[data-ov]',g)||qs('[data-ov]',g);
      if(a)so[i]=a.getAttribute('data-ov');
      qsa('[data-ov]',g).forEach(function(b){b.addEventListener('click',function(){qsa('[data-ov]',g).forEach(function(x){x.classList.remove('is-active');});b.classList.add('is-active');so[i]=b.getAttribute('data-ov');var aux=qs('[data-osel]',g);if(aux)aux.textContent=b.getAttribute('data-ov');upd();});});
    });
    sel.addEventListener('change',function(){var v=variants.find(function(x){return String(x.id)===String(sel.value);});if(v){so=v.options.slice();sync();rndr(v);}});
    function sync(){qsa('[data-oi]',root).forEach(function(g){var i=Number(g.getAttribute('data-oi'));qsa('[data-ov]',g).forEach(function(b){b.classList.toggle('is-active',b.getAttribute('data-ov')===so[i]);});});}
    function upd(){var v=variants.find(function(x){return x.options.every(function(o,i){return o===so[i];});});if(!v)return;sel.value=v.id;rndr(v);}
    function rndr(v){
      var p=qs('[data-price]',root),add=qs('[data-add]',root),satcP=qs('[data-satc-price]',root);
      if(p)p.innerHTML=v.compare_at_price&&v.compare_at_price!==v.price?'<span class="sx-price"><s>'+v.compare_at_price+'</s>'+v.price+'</span>':'<span class="sx-price">'+v.price+'</span>';
      if(satcP)satcP.textContent=v.price;
      if(add){add.disabled=!v.available;add.textContent=v.available?t('add','Add to bag'):t('sold','Sold out');}
      if(satcBtn){satcBtn.disabled=!v.available;satcBtn.textContent=v.available?t('add','Add to bag'):t('sold','Sold out');}
      var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u.toString());
    }
  });

  /* MOBILE PRODUCT CAROUSEL — horizontal scroll-snap with arrow controls + dots */
  qsa('[data-product-carousel]').forEach(function(root){
    var gallery=qs('[data-gallery]',root);
    var prev=qs('[data-carousel-prev]',root);
    var next=qs('[data-carousel-next]',root);
    var dots=qsa('[data-carousel-dot]',root);
    if(!gallery)return;
    var items=qsa('.sx-product__gallery-item', gallery);
    var total=items.length;
    function currentIdx(){
      var w=gallery.clientWidth;
      if(!w) return 0;
      return Math.round(gallery.scrollLeft / w);
    }
    function go(delta){
      var w=gallery.clientWidth;
      if(!w) return;
      var newIdx=Math.max(0, Math.min(total-1, currentIdx() + delta));
      try{ gallery.scrollTo({left: newIdx * w, behavior: 'smooth'}); }
      catch(e){ gallery.scrollLeft = newIdx * w; }
    }
    function updateUI(){
      var idx=currentIdx();
      if(prev) prev.classList.toggle('is-hidden', idx <= 0);
      if(next) next.classList.toggle('is-hidden', idx >= total - 1);
      dots.forEach(function(d,i){d.classList.toggle('is-active', i===idx);});
    }
    if(prev) prev.addEventListener('click', function(e){e.preventDefault(); go(-1);});
    if(next) next.addEventListener('click', function(e){e.preventDefault(); go(1);});
    dots.forEach(function(d,i){
      d.addEventListener('click', function(e){
        e.preventDefault();
        var w=gallery.clientWidth;
        try{ gallery.scrollTo({left: i * w, behavior: 'smooth'}); }
        catch(err){ gallery.scrollLeft = i * w; }
      });
    });
    var scrollT=null;
    gallery.addEventListener('scroll', function(){
      if(scrollT) clearTimeout(scrollT);
      scrollT = setTimeout(updateUI, 50);
    }, {passive:true});
    window.addEventListener('resize', updateUI);
    updateUI();
  });

  /* IMAGE ZOOM — PC: image fits entire viewport. Mobile: 2× fit-contain, pannable, no pinch. */
  qsa('[data-product-root]').forEach(function(root){
    var z=qs('[data-zoom]',root),im=qs('[data-zoom-img]',root),cl=qs('[data-zoom-close]',root);
    if(!z||!im)return;
    var MOBILE_BP=750, MOBILE_SCALE=2.0, PAD_D=20, PAD_M=0;
    var px=0,py=0,sx=0,sy=0,spx=0,spy=0,drag=false,didDrag=false,isMobile=false;
    function clamp(v,a,b){return Math.max(a,Math.min(b,v));}
    function sizeImage(){
      var iw=im.naturalWidth, ih=im.naturalHeight;
      if(!iw||!ih)return;
      var vw=window.innerWidth, vh=window.innerHeight;
      var pad = isMobile ? PAD_M : PAD_D;
      var aw=vw-pad*2, ah=vh-pad*2;
      var fit=Math.min(aw/iw, ah/ih);
      var s = isMobile ? fit*MOBILE_SCALE : fit;
      im.style.width = (iw*s)+'px';
      im.style.height = (ih*s)+'px';
    }
    function maxPan(){
      var iw=im.offsetWidth, ih=im.offsetHeight;
      var vw=window.innerWidth, vh=window.innerHeight;
      return {x:Math.max(0,(iw-vw)/2), y:Math.max(0,(ih-vh)/2)};
    }
    function paint(){
      var l=maxPan();
      px=clamp(px,-l.x,l.x); py=clamp(py,-l.y,l.y);
      im.style.transform='translate3d(calc(-50% + '+px+'px), calc(-50% + '+py+'px), 0)';
    }
    function open(src,alt){
      isMobile = window.innerWidth < MOBILE_BP;
      px=0; py=0; didDrag=false;
      z.classList.toggle('sx-zoom--mobile', isMobile);
      z.classList.toggle('sx-zoom--desktop', !isMobile);
      im.alt = alt || '';
      function ready(){ sizeImage(); paint(); }
      if(im.src !== src){ im.onload = ready; im.src = src; }
      else if(im.complete && im.naturalWidth){ ready(); }
      else { im.onload = ready; }
      z.hidden=false; lock(true);
    }
    function close(){
      z.hidden=true; im.removeAttribute('src');
      im.style.width=''; im.style.height='';
      if(!document.body.classList.contains('sx-menu-open') && !document.body.classList.contains('sx-cart-open')) lock(false);
      px=0; py=0;
    }
    qsa('.sx-product__image',root).forEach(function(img){
      img.addEventListener('click',function(){ open(img.getAttribute('data-zoom-src')||img.currentSrc||img.src, img.alt); });
    });
    if(cl) cl.addEventListener('click', function(e){ e.stopPropagation(); close(); });
    z.addEventListener('pointerdown', function(e){
      if(!isMobile) return; if(e.target === cl) return;
      drag=true; didDrag=false;
      sx=e.clientX; sy=e.clientY; spx=px; spy=py;
      z.classList.add('is-dragging');
      try{ z.setPointerCapture(e.pointerId); }catch(_){}
    });
    z.addEventListener('pointermove', function(e){
      if(!drag) return;
      if(Math.abs(e.clientX-sx) > 4 || Math.abs(e.clientY-sy) > 4) didDrag=true;
      px = spx + (e.clientX-sx); py = spy + (e.clientY-sy);
      paint(); e.preventDefault();
    });
    function endDrag(e){
      if(!drag) return;
      drag=false; z.classList.remove('is-dragging'); paint();
      if(e && z.hasPointerCapture && z.hasPointerCapture(e.pointerId)){ try{ z.releasePointerCapture(e.pointerId); }catch(_){} }
    }
    z.addEventListener('pointerup', endDrag);
    z.addEventListener('pointercancel', endDrag);
    z.addEventListener('click', function(e){
      if(e.target === cl) return;
      if(didDrag){ didDrag=false; return; }
      close();
    });
    z.addEventListener('touchmove', function(e){ if(e.touches && e.touches.length > 1) e.preventDefault(); }, {passive:false});
    z.addEventListener('gesturestart', function(e){ e.preventDefault(); });
    z.addEventListener('gesturechange', function(e){ e.preventDefault(); });
    z.addEventListener('gestureend', function(e){ e.preventDefault(); });
    z.addEventListener('wheel', function(e){ if(e.ctrlKey) e.preventDefault(); }, {passive:false});
    var rT=null;
    window.addEventListener('resize', function(){
      if(z.hidden) return;
      if(rT) clearTimeout(rT);
      rT=setTimeout(function(){
        isMobile = window.innerWidth < MOBILE_BP;
        z.classList.toggle('sx-zoom--mobile', isMobile);
        z.classList.toggle('sx-zoom--desktop', !isMobile);
        sizeImage(); paint();
      }, 80);
    });
    document.addEventListener('keydown', function(e){ if(!z.hidden && e.key === 'Escape') close(); });
  });

  /* FLOATING NAV — per template + collection scroll memory */
  (function(){
    var fn=qs('[data-fnav]'); if(!fn)return;
    var tpl=fn.getAttribute('data-tpl')||'';
    var backBtn=qs('[data-fnav-back]',fn), backSep=qs('.sx-fnav__sep--back',fn), topBtn=qs('[data-fnav-top]',fn);
    var collSection=qs('[data-collection-handle]');
    var collHandle=collSection?collSection.getAttribute('data-collection-handle'):'';
    var SCROLL_KEY='sx_coll_scroll_', BACK_FLAG='sx_back_to_collection';
    function isCollection(){return tpl==='collection';}
    function isProduct(){return tpl==='product';}
    function update(){
      var scrolled=window.scrollY>240;
      fn.classList.toggle('is-visible', scrolled||isCollection()||isProduct());
      if(topBtn) topBtn.hidden = !scrolled;
      if(backBtn){
        var showBack=false;
        if(isCollection()) showBack=scrolled;
        if(isProduct()) showBack=true;
        backBtn.hidden=!showBack;
        if(backSep) backSep.hidden=!showBack;
      }
      if(tpl==='index') fn.classList.toggle('is-visible', scrolled);
    }
    window.addEventListener('scroll', update, {passive:true});
    update();
    if(topBtn) topBtn.addEventListener('click', function(){ window.scrollTo({top:0,behavior:'smooth'}); });
    if(isCollection() && collHandle){
      try{
        var flag=sessionStorage.getItem(BACK_FLAG);
        if(flag===collHandle){
          var y=parseInt(sessionStorage.getItem(SCROLL_KEY+collHandle)||'0',10);
          if(y>0) window.scrollTo(0,y);
          sessionStorage.removeItem(BACK_FLAG);
        }
      }catch(_){}
      var saveT=null;
      window.addEventListener('scroll',function(){
        if(saveT) return;
        saveT=setTimeout(function(){ try{ sessionStorage.setItem(SCROLL_KEY+collHandle, window.scrollY); }catch(_){} saveT=null; }, 150);
      },{passive:true});
      qsa('.sx-card a, .sx-card__title a').forEach(function(a){
        a.addEventListener('click',function(){ try{ sessionStorage.setItem(SCROLL_KEY+collHandle, window.scrollY); }catch(_){} });
      });
    }
    if(isProduct() && backBtn){
      backBtn.addEventListener('click', function(){
        try{
          var url=backBtn.getAttribute('href')||'';
          var m=url.match(/\/collections\/([^\/?#]+)/);
          if(m){ sessionStorage.setItem(BACK_FLAG, m[1]); }
        }catch(_){}
      });
    }
    if('IntersectionObserver' in window){
      var footer=qs('.sx-footer-wrap');
      if(footer){
        new IntersectionObserver(function(entries){
          entries.forEach(function(e){ fn.classList.toggle('is-parked', e.isIntersecting); });
        }, {rootMargin:'0px 0px -40px 0px'}).observe(footer);
      }
    }
  })();

  /* CART PAGE — live qty update via AJAX */
  (function(){
    var page = qs('[data-cart-page-form]'); if(!page) return;
    var inputs = qsa('input[data-cart-qty]', page);
    if(!inputs.length) return;
    var btn = qs('[data-cart-update]', page);
    var totalEl = qs('[data-cart-total]', page);
    function pushUpdates(){
      var data = { updates: {} };
      inputs.forEach(function(inp){
        var k = inp.getAttribute('data-line-key');
        var v = parseInt(inp.value || '0', 10);
        if(k) data.updates[k] = isNaN(v) ? 0 : v;
      });
      if(btn){ btn.disabled = true; btn.dataset.o = btn.dataset.o || btn.textContent; btn.textContent = t('loading','Loading…'); }
      fetch(rt + '/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(data)
      })
        .then(function(r){ if(!r.ok) throw 0; return r.json(); })
        .then(function(cart){
          updCount(cart.item_count || 0);
          if(cart.item_count === 0){ location.reload(); return; }
          if(totalEl) totalEl.textContent = fmt(cart.total_price, cart.currency);
          if(cart.items && cart.items.length){
            cart.items.forEach(function(it){
              var inp = qs('input[data-line-key="' + it.key + '"]', page);
              if(inp){
                inp.value = it.quantity;
                var row = inp.closest('.sx-cart-item');
                var price = row && row.querySelector('[data-line-price]');
                if(price) price.textContent = fmt(it.final_line_price, cart.currency);
              }
            });
            inputs.forEach(function(inp){
              var k = inp.getAttribute('data-line-key');
              var still = cart.items.some(function(it){ return it.key === k; });
              if(!still){ var row = inp.closest('.sx-cart-item'); if(row) row.remove(); }
            });
          }
        })
        .catch(function(){ location.reload(); })
        .finally(function(){ if(btn){ btn.disabled = false; btn.textContent = btn.dataset.o || 'Update'; } });
    }
    var debT;
    inputs.forEach(function(inp){
      inp.addEventListener('change', function(){
        if(debT) clearTimeout(debT);
        debT = setTimeout(pushUpdates, 350);
      });
    });
    page.addEventListener('submit', function(e){
      if(!e.submitter || e.submitter.getAttribute('data-cart-update') !== null){
        e.preventDefault();
        if(debT) clearTimeout(debT);
        pushUpdates();
      }
    });
  })();

  /* MOBILE — block pinch-zoom and double-tap zoom sitewide (homepage + collection + product). Real-user test showed pinch-zoom is the first instinct before discovering the click-to-enlarge zoom. Product page keeps its controlled .sx-zoom overlay opened via click. */
  (function(){
    if(window.innerWidth >= 990) return;
    document.addEventListener('gesturestart', function(e){ e.preventDefault(); }, {passive:false});
    document.addEventListener('gesturechange', function(e){ e.preventDefault(); }, {passive:false});
    document.addEventListener('gestureend', function(e){ e.preventDefault(); }, {passive:false});
    document.addEventListener('touchmove', function(e){ if(e.touches && e.touches.length > 1) e.preventDefault(); }, {passive:false});
    var lastTap = 0;
    document.addEventListener('touchend', function(e){
      var now = Date.now();
      if(now - lastTap < 320) e.preventDefault();
      lastTap = now;
    }, {passive:false});
  })();

  /* INFINITE LOAD-MORE */
  (function(){
    var link=qs('[data-load-more]'), grid=qs('[data-grid]');
    if(!link||!grid) return;
    var loading=false;
    function load(e){
      if(e) e.preventDefault();
      if(loading||!link) return;
      loading=true; link.classList.add('is-loading'); link.textContent=t('loading','Loading…');
      fetch(link.href, {credentials:'same-origin'}).then(function(r){return r.text();}).then(function(html){
        var doc=new DOMParser().parseFromString(html,'text/html'), ng=doc.querySelector('[data-grid]'), nl=doc.querySelector('[data-load-more]');
        if(ng) qsa('.sx-card',ng).forEach(function(c){ grid.appendChild(c); });
        if(nl){ link.href=nl.href; link.classList.remove('is-loading'); link.textContent=t('more','Load more'); loading=false; }
        else { var w=link.closest('.sx-load'); if(w) w.remove(); link=null; }
      }).catch(function(){ if(link){ link.classList.remove('is-loading'); link.textContent=t('more','Load more'); loading=false; } });
    }
    link.addEventListener('click', load);
    if('IntersectionObserver' in window){ var ob=new IntersectionObserver(function(ent){ ent.forEach(function(e){ if(e.isIntersecting) load(); }); }, {rootMargin:'900px 0px'}); ob.observe(link); }
  })();
})();
